// extracted by mini-css-extract-plugin
export default {"wrapper":"CardField_wrapper__gmWNC","title":"CardField_title__yVRv6","value":"CardField_value__xMne-"};